  
  import React from "react";
  
  const RefundFailedModal = ({ message, onClose }) => (
    <div className="other-purchase-modal-overlay">
      <div className="other-purchase-modal-content">
        <h2>Refund Failed</h2>
        <img
          src="/images/failed.png"
          alt="Refund successful"
          className="success-image"
        />

        <p className="purchase-modal-subtitle">
          {message ||
            "We could not process your refund at this time. Please try again later."}
        </p>
        <div className="modal-controls">
          <button className="modal-button proceed-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );

export default RefundFailedModal;